export default "__VITE_ASSET__DMoC$xmF__"